import React, { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

function BackupPanel() {
  const [backupLoading, setBackupLoading] = useState(false);
  const [backupMessage, setBackupMessage] = useState('');

  const handleBackup = async () => {
    if (!window.confirm('Trigger backup now? This will export all Firestore data to Backblaze.')) {
      return;
    }

    setBackupLoading(true);
    setBackupMessage('Starting backup...');

    try {
      const backupFunction = httpsCallable(functions, 'triggerBackup');
      const result = await backupFunction();

      setBackupMessage(`Backup completed successfully! ${result.data.totalDocs} documents backed up.`);
      console.log('Backup result:', result.data);
    } catch (error) {
      setBackupMessage(`Backup failed: ${error.message}`);
      console.error('Backup error:', error);
    } finally {
      setBackupLoading(false);
    }
  };

  return (
    <div className="manage-container">
      <div className="manage-section">
        <h3>Database Backup</h3>
        <p>Manually trigger a full Firestore backup to Backblaze.</p>
        <button
          onClick={handleBackup}
          disabled={backupLoading}
          className="btn-primary"
        >
          {backupLoading ? 'Backing up...' : 'Trigger Backup'}
        </button>
        {backupMessage && <p className="backup-message">{backupMessage}</p>}
      </div>
    </div>
  );
}

export default BackupPanel;
